import { useQuery } from "@tanstack/react-query";
import CmSheetStateMachineService from "../services/api/cmSheet/CmSheetStateMachine.service";
import { CmSheetStateEnum, RefreshReactQuery } from "../constants/AppConstants";
import { CollaboratorCmSheet } from "../types/api/collaborators.type";
import { useEffect } from "react";
import { useNotification } from "./notification.hook";
import { ERROR_LABEL, ERROR_MESSAGE_LABEL } from "../constants/Dictionary";

type useGoalsCardVisibilityProps = {
  profileId: number;
  isMyProfile?: boolean;
  currentCmSheet?: CollaboratorCmSheet;
};
export const useGoalsCardVisibility = ({
  profileId,
  isMyProfile,
  currentCmSheet,
}: useGoalsCardVisibilityProps) => {
  const { notification } = useNotification();

  const { data, isFetching, isError } = useQuery({
    queryKey: [
      `get-goals-card-is-visible-${profileId}`,
      currentCmSheet?.id,
      isMyProfile,
    ],
    queryFn: async () => {
      if (!currentCmSheet) {
        return false;
      }

      if (!isMyProfile) {
        return true;
      }
      const cmSheetStateMachine = await CmSheetStateMachineService.get(
        currentCmSheet.id,
      );

      return (
        (cmSheetStateMachine.currentState === CmSheetStateEnum.FINAL_FEEDBACK &&
          cmSheetStateMachine.isRevisionRequestSent) ||
        cmSheetStateMachine.currentState === CmSheetStateEnum.ARCHIVED_SHEET
      );
    },
    staleTime: RefreshReactQuery.HIGH,
    enabled: !!currentCmSheet,
  });

  useEffect(() => {
    if (isError) {
      notification.error(ERROR_LABEL, ERROR_MESSAGE_LABEL);
    }
  }, [isError]);
  return { data, isFetching, isError };
};
